import Footer from "./footer.jsx";
export default Footer;
